import { render } from "./import-campaign-configuration.vue?vue&type=template&id=5e4f95f0&ts=true"
import script from "./import-campaign-configuration.ts?vue&type=script&lang=ts&external"
export * from "./import-campaign-configuration.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__